
















































































































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import FormHeader from "../../molecules/FormHeader.vue";
import router from "../../../router";
export default createComponent({
  setup(props, context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const inputSearchDateFrom = (e:string) => {
      companyRecruitment.inputSearchDateFrom(e)
    }

    const inputSearchDateTo = (e:string) => {
      companyRecruitment.inputSearchDateTo(e)
    }
    const resetTableValue = companyRecruitment.resetTableValue;
    const getListPrefecture = companyRecruitment.getListPrefecture;
    let urlParams = context.root.$route.query as any
    companyRecruitment.clearSearchParams()
    companyRecruitment.setWorkStartDate(urlParams.start_work_day ? urlParams.start_work_day : '' )
    companyRecruitment.setWorkEndDate(urlParams.end_work_day ? urlParams.end_work_day : '' )
    companyRecruitment.setPreFectureCode(urlParams.prefecture_code ? urlParams.prefecture_code : '' )
    companyRecruitment.setJobPostingStatus(urlParams.state ? urlParams.state : '' )
    
    onMounted(async () => {
      const paramsJobSearch = {
        prefecture: context.root.$route.query.prefecture_code,
        dateFrom: context.root.$route.query.start_work_day,
        dateTo: context.root.$route.query.end_work_day,
        state: context.root.$route.query.state
      };
      await getListPrefecture();
      if (
        !paramsJobSearch.dateFrom &&
        !paramsJobSearch.dateTo &&
        !paramsJobSearch.prefecture &&
        !paramsJobSearch.state
      ) {
        await resetTableValue();
      }
      await companyRecruitment.resetBtnSelectAll();
      if (
        paramsJobSearch.dateFrom ||
        paramsJobSearch.dateTo ||
        paramsJobSearch.prefecture ||
        paramsJobSearch.state ||
        paramsJobSearch.dateFrom == "" ||
        paramsJobSearch.dateTo == "" ||
        paramsJobSearch.prefecture == "" ||
        paramsJobSearch.state == ""
      ) {
        await companyRecruitment.searchJob(
          paramsJobSearch.dateFrom,
          paramsJobSearch.dateTo,
          paramsJobSearch.prefecture,
          paramsJobSearch.state
        );
      }
    });

    const prefectures = companyRecruitment.prefectureName;
    const getTableJobInfor = async (
      dateFrom: any,
      dateTo: any,
      prefecture: any,
      state: any
    ) => {
      await companyRecruitment.clearTableSelected();
      const listPrefectures = companyRecruitment.prefectures;
      await listPrefectures.map((item: any) => {
        if (item.prefecture_name == prefecture) {
          prefecture = item.prefecture_code;
        }
      });
      if (dateFrom == null) dateFrom = "";
      if (dateTo == null) dateTo = "";
      if (router.currentRoute.path === "/company_offer") {
        await router.replace(
          `/company_offer?prefecture_code=${prefecture}&start_work_day=${dateFrom}&end_work_day=${dateTo}&state=${state}`
        , () => {});
        const paramsJobSearch = {
          prefecture: context.root.$route.query.prefecture_code,
          dateFrom: context.root.$route.query.start_work_day,
          dateTo: context.root.$route.query.end_work_day,
          state: context.root.$route.query.state
        };
        await companyRecruitment.searchJob(
          paramsJobSearch.dateFrom,
          paramsJobSearch.dateTo,
          paramsJobSearch.prefecture,
          paramsJobSearch.state
        );
      } else {
        await router.push(
          `/company_offer?prefecture_code=${prefecture}&start_work_day=${dateFrom}&end_work_day=${dateTo}&state=${state}`,
          () => {}
        );
      }
    };

    const jobSearchInfor = computed(() => companyRecruitment.jobSearchInfor);
   const formatDate = (date: string) => displayui.formatDate(date)
    return {
      jobSearchInfor,
      getTableJobInfor,
      prefectures,
      formatDate,
      inputSearchDateFrom,
      inputSearchDateTo
    };
  },
  components: {
    FormHeader
  }
});
